import { Cog6ToothIcon } from '@heroicons/react/24/outline'
import { AuditEventsView } from '../components/AuditEventsView'
import type { ReactNode } from 'react'
import type { AuditEvent, ManagedUser } from '../api'
import type { UserSortKey } from '../lib/userSort'

type Props = {
	sortedRows: ManagedUser[]
	events: AuditEvent[]
	userSortableHeader: (key: UserSortKey, label: string) => ReactNode
	onOpenRow: (row: ManagedUser) => void
	onCreateClick: () => void
}

export function AccountsScreen({ sortedRows, events, userSortableHeader, onOpenRow, onCreateClick }: Props) {
	return (
		<div className="panel">
			<div className="panel-actions">
				<h2>Учётные записи</h2>
				<button type="button" className="primary-btn" onClick={onCreateClick}>
					Создать учётку
				</button>
			</div>
			<table>
				<thead>
					<tr>
						{userSortableHeader('login', 'Логин')}
						{userSortableHeader('full_name', 'Имя')}
						{userSortableHeader('position', 'Должность')}
						{userSortableHeader('permissions', 'Права')}
						{userSortableHeader('active', 'Активен')}
						<th scope="col">Действия</th>
					</tr>
				</thead>
				<tbody>
					{sortedRows.map((row) => (
						<tr key={row.id}>
							<td>{row.login}</td>
							<td>{row.full_name || '-'}</td>
							<td>{row.position || '-'}</td>
							<td>{row.permissions.join(', ') || '-'}</td>
							<td>{row.is_active ? 'Да' : 'Нет'}</td>
							<td>
								<span
									className="icon-bare"
									role="button"
									tabIndex={0}
									aria-label={`Настройки и активность: ${row.login}`}
									onClick={() => void onOpenRow(row)}
									onKeyDown={(e) => {
										if (e.key === 'Enter' || e.key === ' ') {
											e.preventDefault()
											void onOpenRow(row)
										}
									}}
								>
									<Cog6ToothIcon className="hero-icon" aria-hidden="true" />
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			<div className="audit-block audit-block-page">
				<h2>Активность пользователей</h2>
				<AuditEventsView events={events} showLoginColumn />
			</div>
		</div>
	)
}
